import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { useDeletePurchaseOrderComment } from '@/services/apis/mutations/purchase-orders/use-delete-purchase-order-comment';

type PurchaseOrderCommentDeleteProps = {
  commentId: number;
  setOpen: (value: boolean) => void;
  purchaseOrderId: string;
};

export function usePurchaseOrderMainCommentDelete({
  commentId,
  setOpen,
  purchaseOrderId,
}: PurchaseOrderCommentDeleteProps) {
  const { t } = useTranslation('purchaseOrder');
  const { mutate, isPending } = useDeletePurchaseOrderComment(purchaseOrderId);

  const onSubmit = () => {
    mutate(commentId, {
      onSuccess: () => {
        setOpen(false);
      },
      onError: () => {
        toast.error(t('error', { ns: 'common' }), {
          description: t('deletePurchaseOrderCommentError'),
        });
      },
    });
  };

  return {
    onSubmit,
    isSubmitting: isPending,
  };
}
